
import { Component } from '@angular/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MatExpansionModule } from '@angular/material/expansion';
import { Router,RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { ToggleService } from './toggle.service';
import { CommonModule, NgClass } from '@angular/common';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';
import {Endpoints} from "../../customs/endpoints";
import {ApiService} from "../../customs/_services/api.service";
import {LoggerService} from "../../customs/_services/logger.service";
import {finalize, of, tap} from "rxjs";
import {catchError} from "rxjs/operators";
import {MatBadgeModule} from '@angular/material/badge';
import {DialogService} from "../../customs/_modal/dialog.service";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {CommonResponse} from "../../customs/_models/Response";
import { AuthService } from '../../services/user-service/AuthService';

@Component({
    selector: 'app-sidebar',
    providers: [ApiService, Endpoints, DialogService, HttpClient],
    standalone: true,
    imports: [MatBadgeModule,NgScrollbarModule, CommonModule,MatExpansionModule, RouterLinkActive, RouterModule, RouterLink, NgClass],
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
    isSidebarToggled = false;
    isToggled = false;

    totalSamples: number = 0;
    totalClients: number = 0;
    currentYear: number = new Date().getFullYear();

    
    constructor(
        private toggleService: ToggleService,
        private endpoints: Endpoints,
        private http : HttpClient,
        private authService:AuthService,
        public themeService: CustomizerSettingsService
    ) {

        this.fetchData();
        this.toggleService.isSidebarToggled$.subscribe(isSidebarToggled => {
            this.isSidebarToggled = isSidebarToggled;
        });
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }
    isAdmin: boolean = false;  // Variable pour vérifier si l'utilisateur est admin

    ngOnInit() {
        this.fetchData();

        this.authService.user$.subscribe(user => {
          console.log('Utilisateur connecté :', user); 
      
          if (user && user.role && user.role.includes('ADMIN')) {
            this.isAdmin = true;  
            console.log('Rôle détecté : ADMIN');
          } else {
            this.isAdmin = false; 
          }
        });
      }
      
    toggle() {
        this.toggleService.toggle();
    }

    // Mat Expansion
    panelOpenState = false;

    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

    // Sidebar Dark
    toggleSidebarTheme() {
        this.themeService.toggleSidebarTheme();
    }

    // Right Sidebar
    toggleRightSidebarTheme() {
        this.themeService.toggleRightSidebarTheme();
    }

    // Hide Sidebar
    toggleHideSidebarTheme() {
        this.themeService.toggleHideSidebarTheme();
    }

    // Header Dark Mode
    toggleHeaderTheme() {
        this.themeService.toggleHeaderTheme();
    }

    // Card Border
    toggleCardBorderTheme() {
        this.themeService.toggleCardBorderTheme();
    }

    // RTL Mode
    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }




    fetchData() {
        this.http.get(`${this.endpoints.sampler_base_endpoint}/totalSamples`).subscribe({
            next : (response: any) => {
                this.totalSamples = response;
            }
        });
        this.http.get<CommonResponse>(`${this.endpoints.client_base_endpoint}/totalClients`).subscribe({
            next : (response) => {
                if (response.status){
                    this.totalClients = response.data
                }
            }
        });
    }



}
